module.exports = __webpack_public_path__ + "static/media/orange.78c2f7a7.svg";